type WaitingForParams = {
  name: string;
  callback: () => boolean;
  attempts?: number;
  interval?: number;
};
/**
 * Функция ждет, когда callbaсk вернет true
 */
export const waitingFor = ({
  name,
  callback,
  attempts = 20,
  interval = 20
}: WaitingForParams): Promise<void> => {
  return new Promise((resolve, reject) => {
    function retry(attemptsLeft: number) {
      if (callback()) {
        resolve();
        return;
      }

      if (attemptsLeft <= 0) {
        reject(new Error(`Превышен лимит попыток при ожидании ${name}.`));
        return;
      }

      setTimeout(() => retry(attemptsLeft - 1), interval);
    }

    retry(attempts);
  });
}
